import React from 'react';
import {Link} from 'react-router-dom';
import ContentLoader from "react-content-loader"

import createLink from "../../../../libs/createLink";

import Avatar from '../../Avatar';

import Icon from '../../Icon';
import Alert from '../../Alert';
import Report from '../../Report';
import Dropdown from "../../Dropdown";
import ViewMore from "../../ViewMore";
import {Can} from "../../../../ability-context";
import Modal from "../../Modal";
import DateSince from "../../Date";
import SubCommentList from "./SubComments/SubCommentList";
import LikeComment from "../../Like/LikeComment";
import {isNoFollowProfil} from "../../../../libs/helper";
import EncourageSignup from "../../../components2/encourageSignup/EncourageSignup";
import Reader from "../../../../libs/lexical/Reader";


class Comment extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirm: false,
            edit: false,
            toggleSignIn: false,
        };
        this.handleDelete = this.handleDelete.bind(this);
        this.updateComment = this.updateComment.bind(this);
        this.handleReport= this.handleReport.bind(this);
        this.editorRef = React.createRef();
    }

    handleDelete() {
        this.props.deleteComment(this.props._id);
        this.setState({confirm: false});
    }

    updateComment(id, value) {
        this.props.updateComment(id, value);
        this.setState({edit: false});
    }

    handleReport(message){
        if(typeof this.props.handleReport === "function"){
            this.props.handleReport(this.props._id, message)
        }
        else{
            console.log("non fonction");
        }

    }

    handleIfCanAnswer(owner){
        if(this.props.currentUser && this.props.currentUser._id){
            this.props.handleSubCommentAnswer(this.props._id, owner || this.props.owner);
            // let el = document.querySelector('.editor-wrapper');
            // if(el){
            //     el.scrollIntoView(true);
            // }

        } else {
            this.setState({toggleSignIn: !this.state.toggleSignIn})
        }
    }


    render() {
        let heightLimit = 16 * 8;
        let relLinkProfil = {};
        if(this.props.commentsInitialized){
            relLinkProfil = isNoFollowProfil(this.props.owner) ? { rel: "nofollow" } : {};
        }
        return !this.props.commentsInitialized ? (
            <div className={`comment`}>
                <ContentLoader
                    height={50}
                    width={200}
                    speed={2}
                    ariaLabel={false}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="80" rx="3" ry="3" width="350" height="6.4"/>
                    <rect x="0" y="100" rx="3" ry="3" width="380" height="6.4"/>
                    <rect x="0" y="120" rx="3" ry="3" width="201" height="6.4"/>
                    <circle cx="11.86" cy="17.97" r="8.86"/>
                    <rect x="32.78" y="6.61" rx="10" ry="10" width="157.94" height="35.47"/>
                </ContentLoader>
            </div>
        ) : (
            <div
                className={`comment ${(!this.props.isApproved && typeof (this.props.isApproved) !== 'undefined') ? 'pending' : ''}`}>
                <div className={"row"}>
                    {this.props.owner !== null && this.props.owner._id ? (
                        <Link to={createLink("userProfile", this.props.owner)} {...relLinkProfil}>
                            <Avatar avatar={this.props.owner.profile.avatar} gender={this.props.owner.profile.gender}/>
                        </Link>
                    ) : (
                        <Avatar gender="guest"/>
                    )}
                    <div className="wrapper-comment">
                        <div className={"comment-with-options"}>
                            <div className="infos">
                                <div
                                    className={`comment-content`}>
                                    <ViewMore limit={heightLimit} kind={"comment"}>
                                        {this.props.owner !== null && this.props.owner._id ? (
                                            <Link className="username"
                                                  to={createLink("userProfile", this.props.owner)} {...relLinkProfil}>{this.props.owner.username}</Link>
                                        ) : (
                                            <span
                                                className="username unknown mr-8">{this.props.authorName || "*Utilisateur Supprimé*"}</span>
                                        )}

                                        <div className="comment-editor-style">
                                            <Reader text={this.props.text} meta={{
                                                mention : this.props.mentions
                                            }}/>
                                        </div>
                                    </ViewMore>
                                </div>
                            </div>
                            {this.props.currentUser._id ? (
                                <div className="comment-options">
                                    <Dropdown align="right" classNameActive={this.props.timelineCommentsTotal === 1 ? "fixe-one-comment" : ""} closeOnClick={true} activableComponent={(
                                        <Icon type="horizontal-dots"/>
                                    )}>
                                        <div className="dropdown-menu">
                                            <Can action={"delete"} subject={this.props} modelName="Comment">
                                                <li className="menu-item trash"
                                                    onClick={() => this.setState({confirm: true})}><Icon
                                                    type="trash"/> Supprimer
                                                </li>
                                            </Can>
                                            <Can action={"update"} subject={this.props} modelName="Comment">
                                                <li className="menu-item edit"
                                                    onClick={() => this.props.handleEdit({
                                                        parentId : this.props.parentId,
                                                        commentId : this.props._id,
                                                        text : this.props.text,
                                                        mentions : this.props.mentions,
                                                        commentType : this.props.commentType
                                                    })}><Icon
                                                    type="pencil-square"/> Editer
                                                </li>
                                            </Can>
                                            <Can action={"report"} subject={this.props} modelName="Comment">
                                                <li className={"menu-item"}>
                                                    <Report _id={this.props._id}
                                                            kind={"comments"}
                                                            type={"comment"}
                                                            handleReport={this.handleReport}
                                                            title="le commentaire"/>

                                                </li>
                                            </Can>
                                        </div>
                                    </Dropdown>
                                </div>
                            ) : null}
                        </div>
                        <div className="wrapper-link">
                            {(!this.props.isApproved && typeof (this.props.isApproved) !== 'undefined') && (
                                <div className="waiting-mod">En attente de modération</div>)}
                            {this.props.isApproved && (
                                <div className="btn-group">
                                    {this.props._id &&
                                    <LikeComment likeType={this.props.commentType}
                                                 commentId={this.props._id}
                                                 isComment={true}
                                                 isLiked={this.props.isLiked}
                                                 value={this.props.count && this.props.count.like}
                                                 parentId={this.props.parentId}/>
                                    }
                                    <Can action="create" subject="Comment">
                                        ·
                                        <div className="answer"
                                             onClick={() => this.handleIfCanAnswer()}>répondre</div>
                                    </Can>
                                </div>
                            )}
                            <EncourageSignup toggle={this.state.toggleSignIn} handleClose={() => this.setState({toggleSignIn: false})} />
                            &nbsp;
                            <span className="comment-date">
                                ·&nbsp;
                                <DateSince
                                    date={this.props.createdAt}
                                    format={"DD/MM/YYYY"}
                                    className={"ml-4"}
                                    prefix={false}
                                    currentFormat={true}
                                />
                            </span>
                            {/*<span className="text small medium-grey px-4">{this.props.createdAt !== this.props.updatedAt && "(modifié)"}</span>*/}
                            <Modal toggle={this.state.confirm} handleClose={() => this.setState({confirm: false})}>
                                <Alert
                                    text="Voulez vous vraiment supprimer ce commentaire ?"
                                    handleClose={() => this.setState({confirm: false})}
                                    handleDelete={this.handleDelete}
                                />
                            </Modal>
                        </div>
                    </div>
                </div>

                <SubCommentList parentId={this.props.parentId}
                                commentId={this.props._id}
                                handleEdit={this.props.handleEdit}
                                hasSubComments={this.props.subComments}
                                commentType={this.props.commentType}
                                handleSubCommentAnswer={(user)=>this.handleIfCanAnswer(user)}
                                subCommentAnswer={this.props.subCommentAnswer}
                                isAnsweringComment={this.props.isAnsweringComment}
                />
            </div>
        )
    }
}

export default Comment;
